@if (loading) {
  <mat-spinner diameter="20" />
} @else {
  <div class="chips-container" [matTooltip]="tooltip" [matTooltipDisabled]="isMobile">
    <app-badge [image]="weatherTypeImage" [value]="null" />

    <app-badge [colourClass]="temperatureColour" icon="fa-solid fa-temperature-three-quarters" [value]="temperature" />

    <app-badge
      [colourClass]="temperatureFeelsLikeColour"
      icon="fa-solid fa-temperature-three-quarters"
      [value]="temperatureFeelsLike" />

    <app-badge [colourClass]="precipitationColour" icon="fa-solid fa-umbrella" [value]="precipitation" />

    <app-badge icon="fa-solid fa-wind" [value]="wind" />

    <app-badge colourClass="amber" icon="wi wi-sunrise" [value]="sunrise" />

    <app-badge colourClass="amber" icon="wi wi-sunset" [value]="sunset" />
  </div>
}
